
define('template!webshopMenuImagesView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="mm-images-toolbar">\n    <div class="mm-search-ctn">\n        <i class="fa fa-search"></i>\n        <input type="text" class="mm-images-search" placeholder="' +
((__t = ( _.i18n('webshop.menu.images.search', null, 'Search an image') )) == null ? '' : __t) +
'"/>\n    </div>\n    <label class="mm-btn mm-upload">\n        <i class="fa fa-upload"></i> <span class="text">' +
((__t = ( _.i18n('webshop.menu.images.upload', null, 'Upload an image') )) == null ? '' : __t) +
'</span>\n        <input type="file" accept="image/*" style="display:none;"/>\n    </label>\n</div>\n<div class="mm-images-grid"></div>\n';

}
return __p
};});

